import { createSelector } from 'reselect';

export const selectPreviewPanel = (state) => state.PreviewPanel;
export const selectReload = createSelector(
  selectPreviewPanel,
  (PreviewPanel) => PreviewPanel.reload,
);
